(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dakhon-models"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('dakhon-models')){customElements.define('dakhon-models',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const main=this.querySelector('[data-main-image]');const mainLink=this.querySelector('[data-main-link]');const dialog=this.querySelector('dialog');const full=this.querySelector('[data-dialog-image]');this.querySelectorAll('[data-image-link]').forEach(link=>link.addEventListener('click',event=>{event.preventDefault();main.src=link.href;main.alt=link.querySelector('img').alt;mainLink.href=link.href;this.querySelectorAll('[data-image-link]').forEach(item=>item.removeAttribute('aria-current'));link.setAttribute('aria-current','true');}));mainLink.addEventListener('click',event=>{event.preventDefault();full.src=main.src;full.alt=main.alt;dialog.showModal();});this.querySelector('[data-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dakhon-showroom"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dakhon-home')) {
class DakhonHome extends HTMLElement {
connectedCallback() {
if(this.ready)return;this.ready=true;
const logoChoice=this.querySelector('#dk-logo-choice');
const logoPanel=this.querySelector('#dk-logo-file-panel');
const bottlePanel=this.querySelector('#dk-bottle-file-panel');
const bottleMessage=this.querySelector('#dk-bottle-message');
const updateAttachments=()=>{
if(logoChoice&&logoPanel)logoPanel.hidden=logoChoice.value!=='يوجد';
const choice=this.querySelector('[data-bottle-choice]:checked');
if(bottlePanel)bottlePanel.hidden=choice?.value!=='نعم';
if(bottleMessage)bottleMessage.hidden=choice?.value!=='لا';
};
if(logoChoice){
logoChoice.addEventListener('change',updateAttachments);
logoChoice.form.addEventListener('reset',()=>setTimeout(updateAttachments,0));
}
this.querySelectorAll('[data-bottle-choice]').forEach(field=>field.addEventListener('change',updateAttachments));
updateAttachments();
const fragrance=this.querySelector('#dk-fragrance');
const capacity=this.querySelector('#dk-capacity');
if(fragrance&&capacity){
const tola=capacity.querySelector('[data-tola]');
const guard=this.querySelector('#dk-capacity-guard');
const warning=this.querySelector('#dk-capacity-warning');
guard.addEventListener('click',()=>{warning.hidden=false;});

const updateCapacity=()=>{
const locked=!fragrance.value;
capacity.disabled=locked;guard.hidden=!locked;warning.hidden=true;
if(locked)capacity.value='';
const allowed=fragrance.value==='دهن عود'||fragrance.value==='مسك';
if(!allowed&&capacity.value===tola.value)capacity.value='';
if(allowed){tola.hidden=false;tola.disabled=false;capacity.insertBefore(tola,capacity.options[1]);}
else{tola.hidden=true;tola.disabled=true;tola.remove();}
};
fragrance.addEventListener('change',updateCapacity);
fragrance.form.addEventListener('reset',()=>setTimeout(updateCapacity,0));
updateCapacity();
}
const country=this.querySelector('#dk-country');
const national=this.querySelector('#dk-national');
const portPanel=this.querySelector('#dk-port-panel');
const port=this.querySelector('#dk-port');
if(country&&national){
for(const option of Array.from(country.options)){if(option.value==='---'){option.remove();}else if(option.value==='Saudi Arabia'){option.textContent=document.documentElement.lang==='ar'?'المملكة العربية السعودية':'Saudi Arabia';}}
const updateAddress=()=>{
const saudi=country.value==='Saudi Arabia';
national.hidden=!saudi;national.disabled=!saudi;
national.querySelectorAll('[data-national-required]').forEach(field=>field.required=saudi);
const international=Boolean(country.value)&&!saudi;
portPanel.hidden=!international;portPanel.disabled=!international;port.required=international;
this.querySelector('#dk-address-confirm').checked=false;
};
country.addEventListener('change',updateAddress);
country.form.addEventListener('reset',()=>setTimeout(updateAddress,0));
updateAddress();
}
this.addEventListener('click',e=>{
const delta=e.target.closest('[data-delta]');
const input=this.querySelector('#DakhonQuantity');
if(delta){input.value=Math.min(9999,Math.max(300,(parseInt(input.value,10)||300)+Number(delta.dataset.delta)));input.dispatchEvent(new Event('input',{bubbles:true}));}

const dialog=this.querySelector('dialog');
if(e.target.closest('[data-zoom]'))dialog.showModal();
if(e.target.closest('[data-close]')||e.target===dialog)dialog.close();
if(e.target.closest('[data-match]'))this.querySelector('[data-results]').hidden=true;
});
this.querySelector('[data-search]')?.addEventListener('submit',e=>{
e.preventDefault();
const q=this.querySelector('#DakhonSearch').value.trim().toLowerCase();
const match=!q||q.split(/\s+/).every(w=>'دخون الخليج عطر عط ر عطور نموذج نماذج 100 مل تغليف فاخر dakhon perfume sample 100ml dk-01'.includes(w));
this.querySelector('[data-results]').hidden=false;
this.querySelector('[data-match]').hidden=!match;
this.querySelector('[data-no-match]').hidden=match;
});
this.querySelector('[data-search]')?.addEventListener('keydown',e=>{if(e.key==='Escape')this.querySelector('[data-results]').hidden=true;});
}
}
customElements.define('dakhon-home',DakhonHome);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
